














import Vue, { PropType } from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

@Component<ContentEditable>({
  computed: {
    listeners() {
      return { ...this.$listeners, input: this.onInput };
    },
  },
})
export default class ContentEditable extends Vue {
  onInput(e) {
    this.$emit('input', e.target.innerText);
  }

  @Ref('editable') editable!: HTMLDivElement;

  @Watch('value')
  handleChangeValue(val) {
    if (!val) {
      this.editable.innerHTML = null;
    }
  }
  @Prop({ type: String })
  value: string;

  @Prop({ type: Array as PropType<typeof ValidationObserver[]> })
  errorMessages: InstanceType<typeof ValidationObserver>[];

  get isError() {
    return this.errorMessages.length;
  }
}
